<template>
    <div>
        <form class="form" enctype="multipart/form-data" @click="uploadFileFn()">
            <v-icon class="folderIcon">folder</v-icon>
            <div class="chooseBtn" color="primary">Browse...</div>
			
            <p v-show="exampleFile" class="exampleFile" @click.stop="downloadExampleFile()">{{ exampleFileName }} Example File</p>
            <p class="fileName">{{ filename }}</p>
            <code v-if="isShowCode" class="file-content-container" :class="fileDisplayArea?'code-container':''" @click.stop>{{ fileShortenDisplay }}</code>
            <div v-else>
                <div v-show="isHeaderErrorMessage">
                    <code class="file-content-container">{{ mainErrorMsg }}</code>
                </div>

                <code v-show="errorMsgDisplay.length > 0" class="file-content-container" v-html="errorFileLine" />
                <div v-show="errorMsgDisplay.length > 0 " class="error-reason-container">
                    <p v-for="(error, idx) in errorMsgDisplay" :key="'err'+idx" class="err-reason"> Line:{{ error.RowNumber }} &nbsp; {{ error.ExceptionMessage }}</p>
                </div>
            </div>  

            <input ref="file" type="file" accept=".csv" hidden @input="chooseFile()">
        </form>

        <slot name="btn-area" />
        
        <general-dialog :dialog.sync="errorDialog" :header="dialogHeader" :width="dialogWidth">
            <template #content>
                <div class="text-align-center">
                    <i class="fa fa-exclamation-circle error-icon" />
                </div>
                <div class="error-reason-container mt-5 ">
                    <p class="error-subtitle"> Error Detected </p>
                    <p v-for="(error, idx) in mainErrorMsg" :key="'err'+idx" class="err-reason-dialog">{{ error }}</p>
                    <p v-for="(error, idx) in errorMsgDisplay" :key="'err'+idx" class="err-reason-dialog"> Line: {{ error.RowNumber }} &nbsp; {{ error.ExceptionMessage }}</p>
                </div>
            </template>
        </general-dialog>

        <div v-if="step">
            <v-btn
                class="upload-btn"
                color="primary"
                @click="continueStep()"
            >
                Upload
            </v-btn>

            <v-btn
                class="skip-btn"
                color=""
                @click="skipStep()"
            >
                Skip
            </v-btn>
        </div>
    </div>
</template>

<script>
export default {
    props: ["step", "importId", "isCleanData", "exampleFile", "exampleFileName", "isErrorMsg", "errorMsg", "headerErrorMsg"],
    data() {
        return {
            file: null,
            filename: null,
            formData: null,
            dialogWidth: "55%",

            fileDisplayArea: null,
            originalFile: null,
            errorDialog: false,
            uploadErrorMsg: null,
            uploadHeaderErrorMsg: null,
            isUploadErrorMsg: null,
            dialogHeader: "Error Detected"
        };
    },
    computed: {
        isShowCode() {
            if (this.isUploadErrorMsg || this.isErrorMsg) {
                return false;
            }
            else return true; 
        },
        isHeaderErrorMessage() {
            if (this.headerErrorMsg && this.headerErrorMsg.length > 0) {
                return true;
            }
            else if (this.uploadHeaderErrorMsg && this.uploadHeaderErrorMsg.length > 0) {
                return true;
            }
            else return false; 
        },
        mainErrorMsg() {
            if (this.headerErrorMsg) return this.headerErrorMsg;
            else if (this.uploadHeaderErrorMsg) return this.uploadHeaderErrorMsg;
            else return "";
        },
        errorMsgDisplay() {
            if (this.errorMsg) return this.errorMsg;
            else if (this.uploadErrorMsg) return this.uploadErrorMsg;
            else return "";
        },
        errorFileLine() {
            var self = this;
            var errorLine = "";
            if (this.errorMsg || this.uploadErrorMsg) {
                let error_message = this.errorMsg || this.uploadErrorMsg;
                error_message.forEach(error => {
                    let errorRow = error.RowNumber; // +1 is for the header
                    let errorRowUp = errorRow - 1;
                    let errorRowDown = errorRow + 2;

                    errorLine = errorLine + "\t... \n";

                    let lines = self.originalFile.slice(errorRowUp - 1, errorRowDown); //errorRowUp - 1 is becoz the array start with index 0
                    lines.forEach((line, idx) => {
                        let number = (errorRowUp + idx);
                        if (number == errorRow) {
                            errorLine = `${errorLine}<p class="error-line">${number}\t${line}</p>`; 
                        }
                        else {
                            errorLine = errorLine + (number) + "\t" + line;
                        }
                    });
                });
                errorLine = errorLine + "\t... \n";
                return errorLine;
            }
        },
        fileShortenDisplay() {
            if (this.fileDisplayArea) {
                if (this.fileDisplayArea.length > 10) {
                    var first10 = this.fileDisplayArea.splice(1, 10);
                    var myRows = "";
                    first10.forEach(row => {
                        myRows = myRows + row + "\n";
                    });
                    return myRows + "......";
                }
                else return this.fileDisplayArea;
            }
            else return "";
        }
    },
    watch: {
        isCleanData() {
            if (this.isCleanData) {
                this.cleanInputFile();
                this.$emit("update:isCleanData", false);
            }
        }
    },
    methods: {
        downloadExampleFile() {
            window.location.href = this.exampleFile;
        },
        nextStep() {
            var myStep = this.step;
            myStep++;
            this.$emit("update:step", myStep);
        },
        skipStep() {
            this.cleanInputFile();
            this.nextStep();
        },
        continueStep() {
            if (this.filename) {
                this.postUploadFile();
            }
            else {
                EventBus.$emit("snackBar", {
					    text: "File is not selected",
					    snackbarColor: "amber darken-2"
                });
            }
        },
        clearError() {
            this.$emit("update:isErrorMsg", false);
            this.$emit("update:errorMsg", "");

            this.uploadErrorMsg = null;
            this.uploadHeaderErrorMsg = null;
            this.isUploadErrorMsg = null;
        },
        chooseFile() {
            var self = this;
            this.clearError();

            if (this.$refs.file.files[0]) {
                this.file = this.$refs.file.files[0];
                this.filename = this.$refs.file.files[0].name;
            }

            var textType  = /.*vnd.ms-excel/;
            if (this.file.type.match(textType)) {
                var reader = new FileReader();

                reader.onload = function(e) {
                    console.log(e);
                    var text = reader.result;
                    var allLines = text.split("\n");
                    self.fileDisplayArea = [...allLines];
                    self.originalFile = [...allLines];
                };
                reader.readAsText(this.file);	
            } else {
                self.fileDisplayArea = "File not supported!";
            }
                
            this.formData = new FormData();
            this.formData.append("file", this.file);
            this.formData.append("importTableId", this.importId);  
            this.$emit("receiveFormData", this.formData);
        },
        uploadFileFn() {
            this.$refs.file.click();
        },
        postUploadFile() {
            var self = this;
            let formData = new FormData();
            formData.append("file", this.file);
            formData.append("importTableId", this.importId);  
				
            axios({
				  method: "POST",
				  url: "Import/Import",
				  data: formData
            })
                .then(function (response) {
                    EventBus.$emit("snackBar", {
					  text: "File uploaded. Please check the file status in Import Status",
					  snackbarColor: "green"
                    });
                    self.nextStep();
                })
                .catch((error) => {
                    var errorMsg = error.response.data.error.message ?? "Bad Data Found. Please update the data and reupload again";
                    EventBus.$emit("snackBar", {
                        text: errorMsg,
                        snackbarColor: "red darken-2"
                    });
                    var details = JSON.parse(error.response.data.error?.details);
                    self.uploadErrorMsg = details.ReadingErrorList;
                    self.uploadHeaderErrorMsg = details.HeaderMissingList;
                    self.errorDialog = (details.ReadingErrorList.length > 0 ||  details.HeaderMissingList.length > 0) ?  true : false;
                    self.isUploadErrorMsg = true;
                });
        },
        cleanInputFile() {
            $(this.$refs.file).val("");
            this.file = "";
            this.filename = "";
            this.fileDisplayArea = "";
        }
    }
};
</script>

<style lang="css" scoped>
.skip-btn{
    margin: 0 8px 2px 4px;
}
.upload-btn{
    margin: 0 4px 2px 0;
}
.form{
    margin-bottom: 1rem;
    padding: 4rem 2rem 2rem 2rem;
    border: 1px dashed #bdbdbd;
    text-align: middle;
    display: flex;
    flex-direction: column;
    cursor: pointer;
}
.chooseBtn{
    background-color: var(--main-color);
    text-align: center;
    padding: 0.5rem;
    color: #ffffff;
    border-radius: 5px;
    width: 50%;
    margin: auto;
}
.folderIcon{
    font-size: 5rem;
    margin: auto;
    padding: 1rem;
    display: inline-block;
}
.exampleFile{
    margin: auto;
    padding: 0.5rem 0 0 0;
    color: #007bff;
}
.exampleFile:hover{
    text-decoration: underline;
}
.fileName{
    margin: auto;
    padding: 1rem 0 0 0;
}
.file-content-container{
    margin-top: 1rem;
    padding: 0;
    color: #676767;
    cursor: auto;
    width: 100%;
}
.code-container{
    min-height: 100px;
    background-color: #f5f5f5;
    padding: 8px;
    box-shadow: 0 2px 1px -1px rgba(0,0,0,.2), 0 1px 1px 0 rgba(0,0,0,.14), 0 1px 3px 0 rgba(0,0,0,.12);
}
.file-content-container::before, .file-content-container::after{
    letter-spacing: 0px;
    content: '';
}
.error-reason-container{
    padding: 5px 0;
}
.err-reason{
    margin: 2px 0;
    color: #e83e8c;
    font-size: 11px;
}
.err-reason-dialog{
    margin: 2px 0;
    color: #e83e8c;
    font-size: 16px;
}
.error-icon{
    color: red;
    font-size: 45px;
}
.error-subtitle{
    font-size: 18px;
    font-weight: bold;
}
</style>
<style lang="css">
.error-line{
    margin: 0;
    background-color: #e0e0e0;
    color: #e83e8c;
}

</style>


// WEBPACK FOOTER //
// src/components/Action/BatchUploadBrowserContaniner.vue